import { Component, OnInit, OnDestroy, Injector } from "@angular/core";
import { combineLatest, Observable } from "rxjs";
import { mergeMap, map } from "rxjs/operators";
import {

  LoggerService,

  ViewDataService,

} from "world-archery-lib";
import { FiltersSeriesTeamsService } from "../filters-series-teams.service";
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import { TeamRankingIndoorStore } from 'src/app/common-page-components/stores/entities-store/team-ranking-indoor-store';
import { IAthlete } from 'src/app/common-page-components/stores/entities-store/athlete-records-store';
import {animationsTable} from '../../../common-page-components/wa-table/wa-table.component';

@Component({
  selector: "app-indoor-world-series-list",
  templateUrl: "./indoor-world-series-list.component.html",
  styleUrls: ["./indoor-world-series-list.component.scss"],
  animations: animationsTable
})
export class IndoorWorldSeriesListComponent extends TableAbstractComponent
  implements OnInit, OnDestroy {
  headers = [
    { name: 'Ranking', isSortable: true, sortProperty: 'RANKING' },
    { name: 'Club/Team', isSortable: true, sortProperty: 'TEAM' },
    { name: '', isSortable: false },

    { name: "Club/Athletes", isSortable: false },
    { name: "Points", isSortable: true, sortProperty: 'POINTS' },

    { name: "", isSortable: false },

  ];

  detailHeaders = [
    { name: '', isSortable: false, },
    { name: '', isSortable: false, },
    { name: '', isSortable: false, },
    { name: '', isSortable: false, },
    { name: '', isSortable: false, },
    { name: '', isSortable: false, },

  ];
  constructor(
    protected logger: LoggerService,
    private injector: Injector,
    protected views: ViewDataService,
    public filter_service: FiltersSeriesTeamsService
  ) {
    super(injector, filter_service, new TeamRankingIndoorStore(injector));
    this.filter_service.sortLocator.sortingType = 'RANKING' as any;
    this.filter_service.sortLocator.asc = true;
  }

  ngOnInit() {
    this.subscriptions.push(this.getDataStream().subscribe(next => {
    }));
  }
  ngOnDestroy() {
    super.ngOnDestroy();
  }
  getDataStream(): Observable<Array<any>> {
    return combineLatest(
      this.reload.asObservable(),
      this.filter_service.orderValue,
      this.filter_service.categoriesCombo.comboData,
      this.filter_service.yearCombo.comboData,
      this.filter_service.textSearch.data(300),
    ).pipe(
      map(([reload, order, category, season, search]) => {
        const params = {
          Year: season ? season.Year : undefined,
          CatCode: category.Cat,
          fText: search.text,
          SortBy: order.sortingSend,
          Detailed: 1
        };
        return params;
      }),
      mergeMap(params => {
        return this.model.requestData(params, this.request_more_data);
      })
    );
  }

   /**
   * A method for get the score keys from athletes.
   *
   * @returns Array<string>
   * @memberof IndoorWorldSeriesTeamInfoComponent
   */
  getScoreDetailedKeys(athletes:Array<IAthlete>) {
    return athletes.map(value=> value.Id);
  }
  getAthleteInfo(athletes:Array<IAthlete>, scoreKey: string) {
    const index = athletes.findIndex(athlete => athlete.Id.toString() === scoreKey.toString());
    return athletes[index];
  }

  /**
   * A method for get the position details keys from athletes.
   *
   * @returns Array<string>
   * @memberof IndoorWorldSeriesTeamInfoComponent
   */
  getPositionDetailedKeys(athletes:Array<IAthlete>){
    return athletes.map(value=> value.Id);
  }

}
